var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRedo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0199 2.42384C9.70165 2.68901 9.65866 3.16193 9.92383 3.48014L11.3987 5.25H6C3.65279 5.25 1.75 7.15279 1.75 9.5C1.75 11.8472 3.65279 13.75 6 13.75H7.5C7.91421 13.75 8.25 13.4142 8.25 13C8.25 12.5858 7.91421 12.25 7.5 12.25H6C4.48122 12.25 3.25 11.0188 3.25 9.5C3.25 7.98122 4.48122 6.75 6 6.75H11.3987L9.92383 8.51987C9.65866 8.83807 9.70165 9.311 10.0199 9.57617C10.3381 9.84134 10.811 9.79835 11.0762 9.48014L13.5762 6.48014C13.8079 6.20201 13.8079 5.798 13.5762 5.51987L11.0762 2.51987C10.811 2.20166 10.3381 2.15866 10.0199 2.42384Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRedo);
export default ForwardRef;